export const PluginTopComponentResourcesEn = {
    title: "With the plugin, <b>you will never forget</b> about cashback!",
    description:
        "The goodie cashback plugin is a <b>free and secure</b> solution that <b>will automatically</b> inform you about the availability of refunds for online purchases.",
    bonus: "PLN 10 bonus for your first purchase for min. PLN 40 with the goodie plugin",

    browserLabel: "Plugin available for browser:",
    browserAdditional: "Plugin is for computers only and does not currently work on mobile devices",

    btnActive: "Install plugin for free",
    btnInactive: "Browser is not supported",
};
